// FieldConfig.js

export class FieldConfig {
  constructor(key, label, placeholder = "", priority = 1, type = 'input', visibility = '', IsVisible = false,
    //  PagePermission = 'disable'
    //  ,
    place = '', value = "") {
    this.key = key;
    this.label = label;
    this.placeholder = placeholder;
    this.priority = priority;
    this.type = type;
    this.visibility = visibility;
    this.IsVisible = IsVisible;
    // this.PagePermission = PagePermission;
    this.place = place;
    this.value = value;

  }

  // Method to update visibility based on API response
  setVisibility(isVisible) {
    this.isVisible = isVisible;
  }
}




export const StonePopUpFields = [

  new FieldConfig("StoneName", "Stone Name", "", 1, "inputselect", "ReadWrite", true, "top"),
  new FieldConfig("StoneColour", "Color", "", 1, "inputselect", "ReadWrite", true, "top"),

  new FieldConfig("StoneShape", "Shape", "", 1, "inputselect", "ReadWrite", true, "top"),
  new FieldConfig("StoneSize", "Size", "", 1, "inputselect", "ReadWrite", true, "top"),

  new FieldConfig("StoneWeight", "Weight", "", 1, "inputdecimal", "ReadWrite", true, "top"),
  new FieldConfig("StonePieces", "Pieces", "", 1, "inputdecimal", "ReadWrite", true, "top"),

  new FieldConfig("StoneRatePiece", "Rate/Piece", "", 1, "inputdecimal", "ReadWrite", true, "top"),
  new FieldConfig("StoneRateKarate", "Rate/Gram", "", 1, "inputdecimal", "ReadWrite", true, "top"),
  new FieldConfig("StoneAmount", "Amount", "", 1, "inputdecimal", "ReadWrite", true, "top"),
  new FieldConfig("Description", "Description", "", 1, "inputtext", "ReadWrite", true, "top"),
  new FieldConfig("ActionPlus", "Action", "", 1, "Icon", "ReadWrite", true, "top"),
 

];


export const DiamondPopUpFields = [

  new FieldConfig("DiamondShape", "Diamond Shape", "", 1, "inputselect", "ReadWrite", true, "top"),
  new FieldConfig("DiamondClarity", "Diamond Clarity", "", 1, "inputselect", "ReadWrite", true, "top"),

  new FieldConfig("DiamondColour", "Diamond Colour", "", 1, "inputselect", "ReadWrite", true, "top"),
  new FieldConfig("DiamondSleve", "Diamond Sleve", "", 1, "inputselect", "ReadWrite", true, "top"),

  new FieldConfig("DiamondSize", "Diamond Size", "", 1, "inputdecimal", "ReadWrite", true, "top"),
  new FieldConfig("DiamondPieces", "Diamond Pieces", "", 1, "inputnumber", "ReadWrite", true, "top"),
  new FieldConfig("DiamondWeight", "Diamond Weight", "", 1, "inputdecimal", "ReadWrite", true, "top"),

  new FieldConfig("DiamondRate", "Diamond Rate", "", 1, "inputdecimal", "ReadWrite", true, "top"),
  new FieldConfig("DiamondAmount", "Diamond Amount", "", 1, "inputdecimal", "ReadWrite", true, "top"),
  new FieldConfig("DiamondCut", "Diamond Cut", "", 1, "inputdecimal", "ReadWrite", true, "top"),
  new FieldConfig("SettingType", "Setting Type", "", 1, "inputtext", "ReadWrite", true, "top"),
  new FieldConfig("Certificate", "Certificate", "", 1, "inputtext", "ReadWrite", true, "top"),
  new FieldConfig("Description", "Description", "", 1, "inputtext", "ReadWrite", true, "top"),
  new FieldConfig("ActionPlus", "Action", "", 1, "Icon", "ReadWrite", true, "top"),
 

];